/**
 * Fixed UI copy of the checkout (Figma „Nakupný proces“ 60256:12973 and „Objednávka odoslaná“
 * 60260:27183). Words that the core dictionary has letter for letter (Košík, Doprava, Platba,
 * Upraviť, Zhrnutie objednávky …) are read with `t()` in the components; the rest has no dictionary
 * key and is not administration content, so it lives here.
 */
export const CHECKOUT_COPY = {
  steps: {
    label: 'Kroky objednávky',
    details: 'Údaje',
    /** Mobile: „Doprava a platba“ breaks after „Doprava“ (Figma 60460:112724). */
    shippingLines: ['Doprava', 'a platba'],
    done: 'hotovo',
    current: 'aktuálny krok',
  },
  cart: {
    backHome: 'Späť na domovskú stránku',
    remove: 'Odstrániť z košíka',
    quantity: 'Množstvo',
    perUnit: '/',
    giftFallback: 'Ku každej objednávke pribalíme darček zadarmo.',
    related: 'Často kupujú spolu',
  },
  summary: {
    savings: 'Ušetríte na akciách',
    coupon: 'Zľavový kód',
    couponToggle: 'Máte zľavový kód?',
    couponRemove: 'Odstrániť zľavový kód',
    couponDiscount: 'Zľava',
    total: 'Spolu s DPH',
    vat: 'z toho DPH',
    continue: {
      cart: 'Pokračovať k doprave',
      shipping: 'Pokračovať na údaje',
    },
    gatewayNote: 'Po odoslaní vás presmerujeme na platobnú bránu.',
    consent: {
      prefix: 'Súhlasím s ',
      terms: 'obchodnými podmienkami',
      middle: ' a beriem na vedomie ',
      privacy: 'spracovanie osobných údajov',
    },
    heurekaOptOut: 'Nesúhlasím so zaslaním dotazníka spokojnosti (Heureka)',
    failed: 'Objednávku sa nepodarilo odoslať',
  },
  shipping: {
    pickPoint: 'Vybrať výdajné miesto',
    changePoint: 'Zmeniť výdajné miesto',
    pickDate: 'Vybrať termín odberu',
    noShipments: 'Pre zvolenú krajinu momentálne nevieme ponúknuť dopravu.',
    noPayments: 'Spôsob platby vyberiete po zvolení dopravy.',
    unavailable: 'Zvolená doprava nie je pre túto krajinu dostupná. Vyberte prosím inú.',
  },
  details: {
    title: 'Fakturačné a doručovacie údaje',
    back: 'Späť na dopravu a platbu',
    login: {
      title: 'Máte u nás účet?',
      text: 'Prihláste sa a údaje doplníme automaticky. Nakupovať môžete aj bez registrácie.',
    },
    persona: 'Nakupujem ako',
    emailHint: 'Pošleme na neho potvrdenie a stav objednávky.',
    companyBilling: 'Fakturačná adresa (sídlo firmy)',
    streetNumberMissing: 'Doplňte aj číslo domu, napr. Hlavná 24.',
    otherDelivery: {
      individual: 'Doručiť na inú adresu ako fakturačnú',
      company: 'Doručiť na inú adresu ako sídlo firmy (napr. sklad alebo prevádzka)',
    },
    recipient: 'Meno a priezvisko príjemcu',
    recipientPlaceholder: 'Meno Priezvisko',
    recipientCompany: 'Názov spoločnosti',
    recipientCompanyPlaceholder: 'ABC s.r.o.',
    site: 'Názov prevádzky / príjemcu',
    siteContact: 'Kontaktná osoba na mieste',
    poNumber: 'Číslo vašej objednávky (PO)',
    poNumberPlaceholder: 'Uvedieme ho na faktúre',
    note: 'Poznámka pre kuriéra',
    notePlaceholder: 'Napr. zvoňte na Kováč 2. poschodie',
    createAccount: 'Vytvoriť si účet a zbierať vernostné body (heslo nastavíte v e-maile)',
    invalid: 'Skontrolujte prosím zvýraznené údaje.',
  },
  /** Lines the order note carries for the fields the order API has no place for. */
  note: {
    poNumber: 'Číslo objednávky zákazníka (PO)',
    recipient: 'Príjemca',
    siteContact: 'Kontaktná osoba na mieste',
    businessAccount: 'Žiadosť o firemný účet (nákup na faktúru a firemné ceny)',
  },
  review: {
    products: 'Produkty',
    editCart: 'Upraviť košík',
    check: 'Skontrolujte údaje',
    delivery: 'Doručenie',
    back: 'Späť na údaje',
    gatewayInfo: 'Na platobnú bránu vás presmerujeme po odoslaní objednávky.',
  },
  empty: {
    title: 'Váš košík je prázdny',
    text: 'Pozrite si obľúbené kategórie alebo sa prihláste – ak ste si niečo uložili v účte, košík obnovíme.',
    start: 'Začať nakupovať',
  },
  confirmation: {
    title: 'Ďakujeme, objednávka je prijatá!',
    sentTo: 'Potvrdenie sme poslali na',
    updates: 'O každej zmene stavu vás budeme informovať e-mailom a SMS.',
    total: 'Suma s DPH',
    paid: 'Zaplatené',
    received: 'Prijatá',
    sent: 'Odoslaná',
    delivered: 'Doručená',
    download: 'Stiahnuť potvrdenie PDF',
    today: 'dnes',
  },
} as const;
